import { render, staticRenderFns } from "./Tradertype.vue?vue&type=template&id=4bc97285"
import script from "./Tradertype.vue?vue&type=script&lang=js"
export * from "./Tradertype.vue?vue&type=script&lang=js"
import style0 from "./Tradertype.vue?vue&type=style&index=0&id=4bc97285&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports